import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as authActions from '../../actions/auth';
import SignIn from '../../components/Auth/SignIn';
import SignUp from '../../components/Auth/SignUp';
import ForgotPassword from '../../components/Auth/ForgotPassword';
import ResetPassword from '../../components/Auth/ResetPassword';
import {Wrapper} from '../../components/common';

class AuthPage extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isAuthenticated: PropTypes.bool.isRequired,
      token: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    const {auth} = this.props;
    const {isAuthenticated} = auth;
    if (isAuthenticated) {
      this.props.history.replace('/lobby');
    }
  }
  render() {
    const {match} = this.props;
    const {path} = match;
    const pathParts = path.split('/');
    let component;
    switch (pathParts[1]) {
      case 'sign-in': {
        component = <SignIn {...this.props}/>;
        break;
      }
      case 'sign-up': {
        component = <SignUp {...this.props}/>;
        break;
      }
      case 'forgot-password': {
        component = <ForgotPassword {...this.props}/>;
        break;
      }
      case 'reset-password': {
        component = <ResetPassword {...this.props}/>;
        break;
      }
      default: {
        component = <SignIn {...this.props}/>;
        break;
      }
    }
    return (
      <Wrapper>
        <div className="cell cell_full">
          {component}
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({auth}) => ({
  auth,
});
const mapDispatchToProps = dispatch => (
  {dispatch, ...bindActionCreators(authActions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(AuthPage);
